// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import RtlLayout from "./components/RtlLayout";
import { ChartStyle } from "./components/chart";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import NotistackProvider from "./components/NotistackProvider";
import ThemeColorPresets from "./components/ThemeColorPresets";
import ThemeLocalization from "./components/ThemeLocalization";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { DialogProvider } from "contexts/DialogContext";
import { FilterProvider } from "contexts/FilterContext";

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <DialogProvider>
                <FilterProvider>
                  <MotionLazyContainer>
                    <ProgressBarStyle />
                    <ChartStyle />
                    {/* <Settings /> */}
                    <ScrollToTop />
                    <Router />
                  </MotionLazyContainer>
                </FilterProvider>
              </DialogProvider>
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
